import React, { useContext, useEffect } from 'react'

import { Div, Divider, Link, Text } from '@vividseats/vivid-ui-kit'

import AnalyticsContext from '@/context/analytics'
import ProductionListContext from '@/context/productions-list'
import { trackEvent } from '@/utils/analytics/ga360'

interface Props {
    customOnFilterResetAction?: () => void
    withDivider?: boolean
    withBottomPadding?: boolean
}

const OverFiltered: React.FC<Props> = ({
    customOnFilterResetAction,
    withDivider = true,
    withBottomPadding = false,
}) => {
    const {
        dispatch: { onFilterResetAction: defaultOnFilterResetAction },
    } = useContext(ProductionListContext)

    const {
        state: { pageType },
    } = useContext(AnalyticsContext)

    const trackEventAction = `${pageType} Page Over Filtered`
    useEffect(() => trackEvent('FilterUse', trackEventAction), [trackEventAction])

    return (
        <>
            <Div paddingLeft={5} paddingRight={5} paddingBottom={withBottomPadding ? 9 : undefined}>
                <Text size="lg" altFont>
                    {'Try changing your filter preferences or '}
                    <Link
                        href="#"
                        onClick={(e) => {
                            e.preventDefault()
                            const onFilterResetAction = customOnFilterResetAction ?? defaultOnFilterResetAction
                            onFilterResetAction()
                        }}
                        data-testid="over-filtered"
                    >
                        <Text size="lg" underline altFont as="span">
                            clear all
                        </Text>
                    </Link>
                    {' filters.'}
                </Text>
            </Div>
            {!!withDivider && <Divider />}
        </>
    )
}

export default OverFiltered
